// extracted by mini-css-extract-plugin
module.exports = {"container":"DSInfoEdit_container__3iGol","splitGroup":"DSInfoEdit_splitGroup__2ouEa","inputGroup":"DSInfoEdit_inputGroup__3KqJW","actions":"DSInfoEdit_actions__1y6vT"};